import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import * as GmapVue from "gmap-vue";
import "vue-json-pretty/lib/styles.css";
import { BootstrapVue } from "bootstrap-vue";
import JsonViewer from "vue-json-viewer";

locale.use(lang);

Vue.use(ElementUI);
Vue.use(JsonViewer);

Vue.use(GmapVue, {
  load: {
    key: process.env.VUE_APP_MAP_KEY,
    libraries: "visualization",
  },
});

Vue.use(BootstrapVue);

Object.defineProperty(Vue.prototype, "$typedStore", {
  get() {
    return this.$store;
  },
});
